<template>
  <div
    class="rhcn-datepicker"
    :class="{'has-value': innerValue}">
    <el-date-picker
      :popper-class="`date-picker-class ${customClass}`"
      v-model="innerValue"
      :type="type"
      :placeholder="placeholder || $t('message.tableCommon.selectDate')"
      :format="format"
      :value-format="valueFormat"
      :size="size"
      :picker-options="pickerOptions"
      :disabled="disabled"
      @change="changeHandler"
      @focus="onFocus"
      @click.native="onClick">
    </el-date-picker>
    <span class="layer"></span>
  </div>
</template>
<script>
export default {
  name: 'rhcn-datepicker',
  props: {
    type: {
      type: String,
      default: 'date',
    },
    value: {
      type: [Date, String],
      default: null,
    },
    pickerOptions: {
      type: Object,
      default: () => {},
    },
    size: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss',
    },
    valueFormat: {
      type: String,
      default: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerValue: this.value,
      showValue: '',
    };
  },
  methods: {
    changeHandler() {
      this.$emit('update:value', this.innerValue);
      this.$emit('input', this.innerValue);
      this.$emit('change', this.innerValue);
    },
    onFocus(event) {
      this.$emit('focus', event);
    },
    onClick(event) {
      this.$emit('click', event);
    },
  },
  watch: {
    value() {
      this.innerValue = this.value;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
// datepicker
.rhcn-datepicker {
  display: inline-block;
  width: 140px;
  box-sizing: border-box;
  position: relative;
  &.has-value {
    &:focus-within {
      .layer {
        opacity: 1;
      }
      .el-date-editor {
        .el-input__inner {
          background: transparent;
          color: $color-white;
        }
      }
    }
  }
  .el-date-editor {
    position: relative;
    z-index: 1;
    width: 100% !important;
    .el-input__inner {
      padding-left: 6px;
      padding-right: 6px;
      text-align: center;
    }
    .el-input__prefix {
      display: none;
    }
    // .el-input__suffix {
    //   display: none;
    // }
    .el-icon-circle-close {
      color: $color-primary;
      font-weight: 800;
    }
  }
  .layer {
    width: calc(100% - 12px);
    height: 29px;
    background-color: $color-primary;
    position: absolute;
    z-index: 0;
    left: 6px;
    top: 50%;
    border-radius: 2px;
    line-height: 29px;
    font-size: 14px;
    text-align: center;
    word-spacing: 0;
    opacity: 0;
    transition: opacity 0.5s ease-in;
    transform: translateY(-50%);
  }
}
.el-picker-panel {
  padding: 15px;
  border: 0;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.1);
  border-radius: 2px;
  .el-date-picker__header {
    margin-top: 0;
    padding-top: 15px;
    .el-picker-panel__icon-btn {
      color: $color-text-primary;
      font-weight: 800;
      font-size: 14px;
      &:hover {
        color: $color-primary;
      }
    }
    .el-date-picker__header-label {
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
      color: $color-text-primary;
    }
  }
  .el-picker-panel__body {
    background-color: $color-default;
    border-radius: 4px;
    .el-picker-panel__content {
      width: inherit;
    }
  }
  .el-picker-panel__sidebar + .el-picker-panel__body {
    margin: 15px 15px 15px 140px;
  }
  .el-date-table {
    th {
      font-size: 12px;
      color: $color-text-primary;
      font-weight: normal;
    }
    .el-date-table__row:last-child {
      td {
        border-bottom: 1px solid $color-border-active;
      }
    }
    td {
      padding: 0;
      width: 40px;
      height: 40px;
      background-color: $color-white;
      box-sizing: border-box;
      border-right: 1px solid $color-border-active;
      border-top: 1px solid $color-border-active;
      &:first-child {
        border-left: 1px solid $color-border-active;
      }
      div {
        padding: 0;
        height: 40px;
      }
      span {
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 800;
        border-radius: 0;
        color: $color-text-primary;
        background-color: transparent;
      }
      &.current:not(.disabled) {
        background-color: $color-text-primary;
        span {
          background: transparent;
          color: $color-white;
        }
      }
      &.today {
        span {
          color: $color-text-default-button;
        }
      }
      &.disabled {
        background-color: $color-input-disabled;
        span {
          color: rgba(38,67,115,0.4);
        }
      }
    }
  }
  &.date-picker-class > .el-picker-panel__footer > .el-button--text:first-child {
    display: none;
  }
  .popper__arrow {
    display: none;
  }
}
</style>
